webpackJsonp([114276838955818,60335399758886],{

/***/ 112:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(245);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(112);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/favicon.affc9e70.ico";

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _siteConfig = __webpack_require__(253);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _global = __webpack_require__(251);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _theme = __webpack_require__(85);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _favicon = __webpack_require__(349);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page(_ref) {
	  var children = _ref.children;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        _siteConfig2.default.siteTitle
	      ),
	      _react2.default.createElement('meta', { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0' }),
	      _react2.default.createElement('link', { rel: 'icon', href: _favicon2.default }),
	      _react2.default.createElement('link', { href: 'https://fonts.googleapis.com/css?family=Quicksand:500|Roboto:400,700', rel: 'stylesheet' }),
	      _react2.default.createElement('meta', { name: 'description', content: _siteConfig2.default.siteDescription }),
	      _react2.default.createElement('meta', { property: 'og:title', content: _siteConfig2.default.siteTitle }),
	      _react2.default.createElement('meta', { property: 'og:locale', content: 'en_US' }),
	      _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	      _react2.default.createElement('meta', { property: 'og:site_name', content: _siteConfig2.default.siteTitle }),
	      _react2.default.createElement('meta', { property: 'og:url', content: _siteConfig2.default.siteUrl }),
	      _react2.default.createElement('html', { lang: 'en' }),
	      _react2.default.createElement('script', { async: true, src: 'https://www.googletagmanager.com/gtag/js?id=UA-170141347-1' }),
	      _react2.default.createElement(
	        'script',
	        null,
	        '\n              window.dataLayer = window.dataLayer || [];\n              function gtag(){dataLayer.push(arguments);}\n              gtag(\'js\', new Date());\n            \n              gtag(\'config\', \'UA-170141347-1\',{ \'anonymize_ip\': true });\n            '
	      )
	    ),
	    _react2.default.createElement(
	      _styledComponents.ThemeProvider,
	      { theme: _theme2.default },
	      _react2.default.createElement(
	        'div',
	        null,
	        children()
	      )
	    )
	  );
	};
	
	exports.default = Page;
	module.exports = exports['default'];

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  /* http://meyerweb.com/eric/tools/css/reset/\n   v2.0 | 20110126\n   License: none (public domain)\n  */\n  html, body, div, span, applet, object, iframe,\n  h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n  a, abbr, acronym, address, big, cite, code,\n  del, dfn, em, img, ins, kbd, q, s, samp,\n  small, strike, strong, sub, sup, tt, var,\n  b, u, i, center,\n  dl, dt, dd, ol, ul, li,\n  fieldset, form, label, legend,\n  table, caption, tbody, tfoot, thead, tr, th, td,\n  article, aside, canvas, details, embed,\n  figure, figcaption, footer, header, hgroup,\n  menu, nav, output, ruby, section, summary,\n  time, mark, audio, video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    font: inherit;\n    vertical-align: baseline;\n  }\n\n  article, aside, details, figcaption, figure,\n  footer, header, hgroup, menu, nav, section {\n    display: block;\n  }\n\n  body {\n    line-height: 1;\n\n    &::after {\n        content: '';\n        position: fixed;\n        width: 100%;\n        top: 0;\n        left: 50%;\n        transform: translateX(-50%);\n        height:100%;\n        // mix-blend-mode: soft-light;\n        pointer-events: none;\n        background: none;\n        @media screen and (min-width: 50em) {\n          max-width:864px;\n          background: repeating-linear-gradient(\n            to right,\n            transparent 1px,\n            #f3f6f5 2px,\n            transparent 1px,\n            transparent 33%\n          );\n      }\n\n        @media screen and (min-width: 1440px) {\n            max-width: 1440px;\n            background: repeating-linear-gradient(\n              to right,\n              transparent 1px,\n              #f3f6f5 2px,\n              transparent 1px,\n              transparent 20%\n            );\n\n           }\n\n    }\n  }\n\n  ol, ul {\n    list-style: none;\n  }\n\n  blockquote, q {\n    quotes: none;\n  }\n\n  blockquote:before, blockquote:after,\n  q:before, q:after {\n    content: '';\n    content: none;\n  }\n\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n\n  * {\n    box-sizing: border-box;\n  }\n\n  body {\n    background: white;\n    font-size: 100%;\n    -webkit-text-size-adjust: 100%;\n    font-variant-ligatures: none;\n    -webkit-font-variant-ligatures: none;\n    text-rendering: optimizeLegibility;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    text-shadow: rgba(0, 0, 0, .01) 0 0 1px;\n    font-weight: 400;\n    font-family: 'Roboto', sans-serif;\n  }\n\n  h1, h2, h3, h4, h5 {\n      font-family: 'Quicksand', sans-serif;\n  }\n\n  img {\n    display: block;\n  \twidth: 100%;\n  \theight: auto;\n  }\n  \n  a.activeLinkStyle, button.activeLinkStyle {\n    &:after {\n      content: '';\n      position: absolute;\n      width: 100%;\n      height: 2px;\n      background: white;\n      left: 0;\n      top: 52px;\n      \n      @media (min-width: 800px) {\n        top: 28px;\n      }\n    }\n  }\n  \n  button.activeLinkStyle {\n    &:after {\n      content: '';\n      position: absolute;\n      width: 100%;\n      height: 2px;\n      background: white;\n      left: 0;\n      top: 35px;\n      \n      @media (min-width: 800px) {\n        top: 28px;\n      }\n    }\n  }\n  \n  .sr-only {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n  }\n"], ["\n  /* http://meyerweb.com/eric/tools/css/reset/\n   v2.0 | 20110126\n   License: none (public domain)\n  */\n  html, body, div, span, applet, object, iframe,\n  h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n  a, abbr, acronym, address, big, cite, code,\n  del, dfn, em, img, ins, kbd, q, s, samp,\n  small, strike, strong, sub, sup, tt, var,\n  b, u, i, center,\n  dl, dt, dd, ol, ul, li,\n  fieldset, form, label, legend,\n  table, caption, tbody, tfoot, thead, tr, th, td,\n  article, aside, canvas, details, embed,\n  figure, figcaption, footer, header, hgroup,\n  menu, nav, output, ruby, section, summary,\n  time, mark, audio, video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    font: inherit;\n    vertical-align: baseline;\n  }\n\n  article, aside, details, figcaption, figure,\n  footer, header, hgroup, menu, nav, section {\n    display: block;\n  }\n\n  body {\n    line-height: 1;\n\n    &::after {\n        content: '';\n        position: fixed;\n        width: 100%;\n        top: 0;\n        left: 50%;\n        transform: translateX(-50%);\n        height:100%;\n        // mix-blend-mode: soft-light;\n        pointer-events: none;\n        background: none;\n        @media screen and (min-width: 50em) {\n          max-width:864px;\n          background: repeating-linear-gradient(\n            to right,\n            transparent 1px,\n            #f3f6f5 2px,\n            transparent 1px,\n            transparent 33%\n          );\n      }\n\n        @media screen and (min-width: 1440px) {\n            max-width: 1440px;\n            background: repeating-linear-gradient(\n              to right,\n              transparent 1px,\n              #f3f6f5 2px,\n              transparent 1px,\n              transparent 20%\n            );\n\n           }\n\n    }\n  }\n\n  ol, ul {\n    list-style: none;\n  }\n\n  blockquote, q {\n    quotes: none;\n  }\n\n  blockquote:before, blockquote:after,\n  q:before, q:after {\n    content: '';\n    content: none;\n  }\n\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n\n  * {\n    box-sizing: border-box;\n  }\n\n  body {\n    background: white;\n    font-size: 100%;\n    -webkit-text-size-adjust: 100%;\n    font-variant-ligatures: none;\n    -webkit-font-variant-ligatures: none;\n    text-rendering: optimizeLegibility;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    text-shadow: rgba(0, 0, 0, .01) 0 0 1px;\n    font-weight: 400;\n    font-family: 'Roboto', sans-serif;\n  }\n\n  h1, h2, h3, h4, h5 {\n      font-family: 'Quicksand', sans-serif;\n  }\n\n  img {\n    display: block;\n  \twidth: 100%;\n  \theight: auto;\n  }\n  \n  a.activeLinkStyle, button.activeLinkStyle {\n    &:after {\n      content: '';\n      position: absolute;\n      width: 100%;\n      height: 2px;\n      background: white;\n      left: 0;\n      top: 52px;\n      \n      @media (min-width: 800px) {\n        top: 28px;\n      }\n    }\n  }\n  \n  button.activeLinkStyle {\n    &:after {\n      content: '';\n      position: absolute;\n      width: 100%;\n      height: 2px;\n      background: white;\n      left: 0;\n      top: 35px;\n      \n      @media (min-width: 800px) {\n        top: 28px;\n      }\n    }\n  }\n  \n  .sr-only {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n  }\n"]);
	
	var _styledComponents = __webpack_require__(7);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	(0, _styledComponents.injectGlobal)(_templateObject);

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var theme = {
	  colors: {
	    base: "#16233e",
	    secondary: "#50e3c2",
	    tertiary: "#f3f3f3",
	    highlight: "#5b8bf7",
	    blue: "#254ea4",
	    grey: "#edf3f2",
	    greyMedium: "#E4EAEB",
	    greyDark: "#cddfdb",
	    black: "#02003c"
	  },
	  sizes: {
	    maxWidth: "864px", // 1200 original
	    maxWidthCentered: "650px"
	  },
	  responsive: {
	    small: "35em",
	    medium: "50em",
	    large: "1200px"
	  }
	};
	
	exports.default = theme;
	module.exports = exports["default"];

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	  siteTitle: "Huvaros",
	  siteDescription: "Huvaros website",
	  siteUrl: "https://www.huvaros.com" // Site domain. Do not inculde a trailing slash! If you wish to use a path prefix you can read more about that here: https://www.gatsbyjs.org/docs/path-prefix/
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-65702374032f68c9ce95.js